import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';
import { BackendSuccessResponse } from '@/types/response/BackendSuccessResponse';
import { CreateCheckoutSessionRequest } from '$/requests/CreateCheckoutSession.ts';

const useCreateCheckoutSession = () => {
  const client = supabaseClient;

  const mutationFn = async (request: CreateCheckoutSessionRequest) => {
    return createSession(client, request);
  };

  return useMutation({
    mutationFn,
  });
};

export default useCreateCheckoutSession;

async function createSession(
  client: SupabaseClient,
  request: CreateCheckoutSessionRequest
): Promise<
  BackendSuccessResponse<{
    sessionId: string;
  }>
> {
  const { data, error } = await client.functions.invoke('create_checkout_session', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();

    throw new Error(errorResponse.errors.join(', '));
  }

  return data;
}
